import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import UpdateSection from "./components/UpdateSection";
import PickSection from "./components/PickSection";
import RankSection from "./components/RankSection";
import AuthorSection from "./components/AuthorSection";
import FaqSection from "./components/FaqSection";
import { comics } from "@/mocks/comics";

const websiteSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "可可漫画网",
      url: "https://adorabook.github.io/",
      description:
        "可可漫画网专注萌系少女与甜宠题材，收录可爱画风、软萌角色恋爱漫画，每日更新，分类清晰，点开即看。",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://adorabook.github.io/category/all?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "ItemList",
      itemListElement: comics.slice(0, 8).map((c, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: c.title,
        url: `https://adorabook.github.io/comic/${c.id}`,
      })),
    },
    {
      "@type": "FAQPage",
      mainEntity: [
        { "@type": "Question", name: "可可漫画网是免费的吗？", acceptedAnswer: { "@type": "Answer", text: "是的，可可漫画网上的萌系漫画、甜宠漫画和恋爱漫画都可以在线免费阅读，无需下载客户端，点开即可看。" } },
        { "@type": "Question", name: "漫画多久更新一次？", acceptedAnswer: { "@type": "Answer", text: "我们坚持每日更新，热门连载通常每周更新1到2话，完结作品会一次性放出全集。" } },
      ],
    },
  ],
};

export default function Home() {
  return (
    <div className="bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <UpdateSection />
        <PickSection />
        <RankSection />
        <AuthorSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
    </div>
  );
}